// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, IconButton, TextField, Tooltip } from "@mui/material";

// material icons
import { Edit } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import BackButton from "components/shared/BackButton";
import PaginationCM from "components/shared/Pagination";

// helper
import Toast from "helper/toast";
import GenerateHeadCell from "helper/generate-head-cell";

// styled component
import { StyledStack, StyledTitle, ButtonContainer } from "./subcategory.style";

// request methods
import { getProductCategoryByIdRequest } from "api/requests/products";

// validation
import { categorySchema } from "validations";

// subcategory head cells
const headCells = GenerateHeadCell("products_subcategory_list");

export default function ProductsSubCategory() {
  const { products_category_id } = useParams();

  const navigate = useNavigate();
  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  // category title state
  const [categoryTitle, setCategoryTitle] = useState("");

  // category data state
  const [subCategoryData, setSubCategoryData] = useState({
    data: [],
    count: 0,
  });

  // get category data
  const getCategoriesData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: getProductCategoryByIdRequest,
      values: {
        id: products_category_id,
      },
    });

    if (res) {
      setCategoryTitle(res.data.title);
      reset({
        title: res.data.title,
      });

      if (res.data.sub_categories.length < 1) {
        return setSubCategoryData({
          count: res.data.sub_categories.length,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }

      let transformedData = res.data.sub_categories.map((items) => ({
        id: items.id,
        title: items.title,
        edit: (
          <IconButton
            color="primary"
            onClick={() => {
              navigate(
                "/products/category/" +
                  products_category_id +
                  "/subcategory/edit/" +
                  items.id
              );
            }}
          >
            <Tooltip title="ویرایش" placement="top">
              <Edit />
            </Tooltip>
          </IconButton>
        ),
      }));

      setSubCategoryData({
        data: transformedData,
        count: res.data.sub_categories.length,
      });
    }

    setLoading(false);
  }, [page]);

  useEffect(() => {
    getCategoriesData();
  }, [getCategoriesData]);

  return (
    <DrawerCM title="لیست زیردسته محصولات">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route={`/products/category`} />
            </Grid>

            <Grid container>
              <Grid item xs={12} my={2}>
                <TableCM
                  title={`لیست زیردسته های ${categoryTitle}`}
                  rows={subCategoryData.data}
                  headCells={headCells}
                  page={page}
                  addProductsSubCategory
                  category_id={products_category_id}
                  colspan={subCategoryData.count === 0 ? "11" : ""}
                  fontSize="12px"
                  cellFontSize="12px"
                />
              </Grid>
              {subCategoryData.count < 1 ? (
                ""
              ) : (
                <PaginationCM
                  handleChange={(_, val) => setPage(val)}
                  page={page}
                  count={subCategoryData.count}
                />
              )}
            </Grid>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
